<template>
  <div>
    <div class="div-title">
      <h4 class="title">Agregar Accesos de {{ datosUsuario.username }}</h4>
      <h4 class="title" v-if="selectedService">
        en {{ selectedService.nombre }}
      </h4>
      <!-- <h4 class="nombre">
         ({{ datosUsuario.run }})
      </h4> -->
    </div>

    <section v-if="user && !selectedService" class="cuerpo">
      <div
        class="servicio"
        v-for="(servicio, index) in user.servicios"
        :key="index"
        @click="establecerServicio(servicio)"
      >
        <span class="s-nombre">{{ servicio.nombre }}</span>
        <i class="bx bx-right-arrow-alt"></i>
      </div>
    </section>
    <div class="loading" v-else-if="!user && !selectedService">
      <Loading />
    </div>
    <section class="cuerpo" v-if="selectedService">
      <div class="role-in">
        <div class="text-width">
          <label class="label-text">Perfil</label>
        </div>
        <b-form-select
          class="input"
          v-model="newData.rol"
          :options="profileOptions"
        ></b-form-select>
      </div>

      <div class="boton">
        <b-button
          @click="confirmChange"
          class="opt-btn blue"
          v-b-tooltip.hover
          title="Confirmar Cambios"
          ><i class="bx bx-check"></i
        ></b-button>
        <b-button
          @click="eliminarDeServicio"
          class="opt-btn red"
          v-b-tooltip.hover
          title="Eliminar de Este Servicio"
          ><i class="bx bx-trash"></i
        ></b-button>
      </div>
    </section>
    <div class="boton">
      <b-button class="btn-cerrar" @click="closeModal">
        Cerrar
      </b-button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/components/tools/Loading.vue";
import Swal from "sweetalert2";
import { showAlert } from "@/components/tools/utils";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      selectedService: null,
      user: null,
      newData: {
        rol: null,
        usuario: this.datosUsuario.id,
        servicio: null,
      },
      toEditService: null,
    };
  },
  props: ["datosUsuario", "closeModal", "profileOptions"],
  methods: {
    requestUserData: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/usuarios/usuarios/${this.datosUsuario.id}/`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.user = res.data;
      } catch (error) {
        console.log(error);
      }
    },

    establecerServicio: function(obj) {
      this.selectedService = obj;
      this.newData.rol = this.selectedService.rolId;
      // console.log(obj);
    },
    confirmChange: async function() {
      Swal.fire({
        title: "¿Está seguro de realizar estos cambios?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios.patch(
              `${process.env.VUE_APP_RUTA_API}/instituciones/usuarioservicio/${this.selectedService.usuarioServicioId}/`,
              { ...this.newData, servicio: this.selectedService.id },
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            Swal.fire(
              "Confirmado!",
              "Usuario modificado en este servicio!",
              "success"
            );
            this.closeModal();
          } catch (error) {
            showAlert({
              icon: "error",
              text: error.response.data[Object.keys(error.response.data)[0]],
              timerProgressBar: true,
              timer: 3000,
            });
          }
        }
      });
    },
    eliminarDeServicio: async function() {
      console.log(this.selectedService.usuarioServicioId);
      Swal.fire({
        title: "¿Está seguro de realizar esta acción?",
        text: "Esta acción es irreversible.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios.delete(
              `${process.env.VUE_APP_RUTA_API}/instituciones/usuarioservicio/${this.selectedService.usuarioServicioId}/`,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            Swal.fire(
              "Confirmado!",
              "Usuario eliminado este servicio!",
              "success"
            );
            this.closeModal();
          } catch (error) {
            showAlert({
              icon: "error",
              text: error.response.data[Object.keys(error.response.data)[0]],
              timerProgressBar: true,
              timer: 3000,
            });
          }
        }
      });
    },
  },
  mounted() {
    this.requestUserData();
    // console.log(this.datosUsuario);
  },
};
</script>
<style scoped>
.title {
  color: #052333;
  margin: 0 !important;
  font-weight: bold;
  text-align: center;
}
.nombre {
  font-weight: 200;
  margin: 0 !important;
}
.cuerpo {
  padding: 20px 20px 0 20px;
}
.servicio {
  padding: 7px;
  background: #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-bottom: 5px;
}
.div-title {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #24c6ab;
  height: 80px;
}
.s-nombre {
  font-weight: bold;
  font-size: 14px;
  color: #052333;
}
.role-in {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bx-right-arrow-alt {
  font-size: 22px;
  color: #052333;
}
.boton {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
}
.opt-btn {
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 20px;
  font-size: 1rem;
  margin: 0 15px;
  padding: 0;
}
.red {
  background: #e73f4b;
}
.blue {
  background: #0069d9;
}
.btn-cerrar {
  background: #e73f4b;
  border-radius: 40px;
  border: none;
  margin: 0 20px;
}
.input {
  background: #e0e0e0;
  border: none;
  width: 250px;
  font-size: 14px;
  color: #595959;
  padding: 0.4rem;
}

.label-text {
  font-size: 14px;
}
.text-width {
  width: 20%;
}
</style>
